import { useEffect, useState } from "react";
import { Edit, Typography } from "@pankod/refine-mui";
import { useForm } from "@pankod/refine-react-hook-form";
import { useOne } from "@pankod/refine-core";

import { useNavigation } from "@pankod/refine-core";
import { toast } from "react-toastify";

import Fields from "./Fields";

import axios from "utils/axios";
import { normalizeData, separatePrimitiveAndObjectFields } from "utils/utils";
import useLocales from "locales/useLocales";

export default function Comp({ routeName, parentName }) {
  const { currentLang, defaultLang } = useLocales();

  const {
    refineCore: { formLoading, queryResult },
    saveButtonProps,
    register,
    control,
    formState: { errors },
    getValues,
    setError,
    setValue,
    watch,
  } = useForm({
    refineCoreProps: {
      metaData: {
        populate: {
          localizations: true,
          prezziari: {
            populate: ["treatments"],
          },
        },
        fakeParam: currentLang.value, //this is to force re-fetching data when language changes
      },
    },
  });

  const { push } = useNavigation();

  const path = parentName ? `${parentName}/${routeName}` : `${routeName}`;

  const emptyTreatment = { name: "", pricePerPerson: "", disabled: false };

  const emptyPrezziario = {
    tot_guests: 1,
    base_price: 0,
    children_price: 0,
    breakfast_included: false,
    treatments: [emptyTreatment],
  };

  const [prezziari, setPrezziari] = useState(Array(10).fill(emptyPrezziario)); //risolve un glitch che creava dei problemi di caricamento di alcuni dati

  //console.log("queryRes: ", queryResult.data?.data.prezziari);
  register("prezziari");
  var initial_prezziari = watch("prezziari");

  useEffect(() => {
    //console.log("initial: ", initial_prezziari);
    if (
      initial_prezziari &&
      initial_prezziari.length > 0 &&
      initial_prezziari[0].id //mi serve per non farlo rompere al click del pulsante save, quando prezziari viene reimpostato
    ) {
      var modified_prezziari = [...initial_prezziari];
      for (var prezziario of modified_prezziari) {
        if (prezziario.treatments.length === 0)
          prezziario.treatments = [emptyTreatment];
        else {
          //aggiungo la proprietà disabled a tutti i treatment
          for (var treatment of prezziario.treatments) {
            if (prezziario.breakfast_included && treatment.name === "BB")
              treatment.disabled = true;
            else treatment.disabled = false;
          }
        }
      }
      //setPrezziari(modified_prezziari);
      //console.log("modified: ", modified_prezziari);
      setPrezziari(modified_prezziari);
    }
  }, [initial_prezziari]);

  // console.log("prezziari: ", prezziari);

  const handleEdit = async (e, values) => {
    e.preventDefault();

    try {
      // questo funziona per il create. per l'edit è più complicato
      //console.log("Salvataggio dati.......");
      var prezziari_ids = [];
      //per ogni prezziario invio prima i treatments
      for (var prezziario of prezziari) {
        var treatment_ids = [];
        for (var treatment of prezziario.treatments) {
          if (treatment.name != "" && treatment.pricePerPerson >= 0) {
            //console.log("id treatment: ", treatment.id);
            //se ha già un id faccio put altrimenti post
            const { data, status } = treatment?.id
              ? await axios.put(`/api/treatments/${treatment.id}`, {
                  data: treatment,
                })
              : await axios.post("/api/treatments", {
                  data: treatment,
                });
            if (status === 200) treatment_ids.push(normalizeData(data).id); //e colleziono gli id dei record creati
          }
        }
        // console.log(prezziario);
        //poi invio il prezziario
        if (prezziario.base_price > 0 && prezziario.tot_guests > 0) {
          //se ha già un id faccio put altrimenti post
          const { data, status } = prezziario?.id
            ? await axios.put(`/api/prezziarios/${prezziario.id}`, {
                data: {
                  tot_guests: prezziario.tot_guests,
                  base_price: prezziario.base_price,
                  children_price: prezziario.children_price,
                  breakfast_included: prezziario.breakfast_included,
                  treatments: treatment_ids,
                },
              })
            : await axios.post("/api/prezziarios", {
                data: {
                  tot_guests: prezziario.tot_guests,
                  base_price: prezziario.base_price,
                  children_price: prezziario.children_price,
                  breakfast_included: prezziario.breakfast_included,
                  treatments: treatment_ids,
                },
              });
          if (status === 200) prezziari_ids.push(normalizeData(data).id);
        }
      }
      setValue("prezziari", prezziari_ids);

      /////////////////////////////////send update to all languages////////////////////////
      //collect all localization ids
      let data = queryResult.data.data;
      let ids = [{ id: data.id, locale: defaultLang }];
      if (data.localizations)
        for (let locale of data.localizations)
          ids.push({ id: locale.id, locale: locale.locale });

      console.log(ids);
      //separate primitives and arrays and objects
      let { primitives, arraysAndObjects } =
        separatePrimitiveAndObjectFields(values);

      //collect all localized fields by scanning through the input and textarea tags in the DOM
      let localizedFields = [];
      let inputs = document.getElementsByTagName("input");
      let textareas = document.getElementsByTagName("textarea");
      for (let element of inputs) {
        let name = element.getAttribute("name");
        let localized = element.getAttribute("data-localized") == "true";
        if (localized) localizedFields.push(name);
      }
      for (let element of textareas) {
        let name = element.getAttribute("name");
        let localized = element.getAttribute("data-localized") == "true";
        if (localized) localizedFields.push(name);
      }

      const filteredKeys = Object.keys(values).filter(
        (item) => !localizedFields.includes(item)
      );
      const nonLocalizedData = {};
      filteredKeys.forEach((item) => (nonLocalizedData[item] = values[item]));
      //console.log("localized ", localizedData);
      //console.log("nonLocalized ", nonLocalizedData);

      const nonLocalizedPrimitives = {};
      const nonLocalizedPrimitiveKeys = Object.keys(primitives).filter(
        (item) => !localizedFields.includes(item)
      );
      nonLocalizedPrimitiveKeys.forEach(
        (item) => (nonLocalizedPrimitives[item] = values[item])
      );

      //put data to all ids
      for (let id of ids) {
        //console.log(id.locale);
        //create payload
        let payload = {};
        if (currentLang.value == defaultLang) {
          if (id.locale == defaultLang) {
            payload = values;
            payload.prezziari = prezziari_ids; //serve forzarlo, altrimenti non lo aggiorna
            //console.log(payload);
          } else {
            payload = nonLocalizedPrimitives;
            //console.log(payload);
          }
        } else {
          if (id.locale == defaultLang) {
            payload = nonLocalizedData;
            payload.prezziari = prezziari_ids; //serve forzarlo, altrimenti non lo aggiorna
            //console.log(payload);
          } else {
            if (id.locale == currentLang.value) {
              payload = primitives;
              //console.log(payload);
            } else {
              payload = nonLocalizedPrimitives;
              //console.log(payload);
            }
          }
        }

        //send PUT request
        let { data } = await axios.put(`/api/${routeName}/${id.id}`, {
          data: payload,
        });
      }
      push(`/${path}`, "_self"); //redirect to list page
    } catch (error) {
      console.log("Edit Error", error);
      toast.error("Something went wrong while editing entries");
    }
  };

  return (
    <Edit
      resource="rate-plans"
      isLoading={formLoading}
      saveButtonProps={{ onClick: (e) => handleEdit(e, getValues()) }}
      title={<Typography variant="h5">Modifica Piano tariffario</Typography>}
      headerButtons={() => {}}
    >
      <Fields
        register={register}
        control={control}
        errors={errors}
        getValues={getValues}
        setError={setError}
        setValue={setValue}
        watch={watch}
        disabled={false}
        prezziari={prezziari}
        setPrezziari={setPrezziari}
        emptyPrezziario={emptyPrezziario}
      />
    </Edit>
  );
}
